/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/9/2
 * @updateTime 2021/9/2
 * @decription 申请担保-代理人相关处理js
 * @namespace 【dlr】
 */
import {Dialog} from 'vant';
import {
    typeDlrlx
} from '@/filters/index';
// 原告代理人编辑组件
import appGuaranteeAddDlr from '../../addGuarantee/addDLR/index.vue';
export default {
    // 依赖组件
    components: {appGuaranteeAddDlr},
    // 数据
    data() {
        return {
            // 代理人数据列表
            dlrDataList: [],
            // 是否显示代理人弹层
            dlrShowPopup: false,
            // 正在编辑的代理人信息项
            dlrEditItem: null,
            // 正在编辑的代理人信息项索引
            dlrEditIndex: -1,
            // 代理人删除的id集合
            dlrDelIds: [],
            // 代理人是否加载完成
            dlrLoaded: false,
            // 代理人标签
            dlrLabel: '原告代理人'
        };
    },
    computed: {
        // 代理人id对应的属性名
        dlrIdProp() {
            return this.fromSQBG ? 'cYdbDlrid' : 'cDbDlrid';
        }
    },
    // 方法
    methods: {

        /**
         * 代理人数据
         * @param {Array<Object>} data 申请人数据列表
         * @returns {void}
         * */
        initDlrData(data) {
            // 申请人数据列表
            const _dlrDataList = [];
            // 循环遍历数据处理数据
            data.forEach((item) => {
                // 转义代理人类型
                item.cDlrlxText = typeDlrlx(item.cDlrlx);
                _dlrDataList.push(item);
            });
            // 赋值代理人数据列表
            this.dlrDataList = _dlrDataList;
            // 代理人加载完成
            this.dlrLoaded = true;
            // 上传材料同步代理人数据
            this.scclSyncDlrData();
        },

        /**
         * 添加、编辑代理人
         * @param {Object} item 代理人信息项数据
         * @param {Number} index 索引
         * @returns {void}
         * */
        dlrAddAEdit(item = null, index = -1){
            if (item) {
                this.dlrEditItem = item;
                this.dlrEditIndex = index;
            }
            // 生成代理人表单
            this.dlrShowPopup = true;
        },

        /**
         * 删除代理人
         * @param {String} id 申请人id
         * @param {Number} index 当前申请人索引
         * @returns {void}
         * */
        dlrDelete(id, index) {
            Dialog.confirm({
                title: '提示',
                message: '删除代理人后，对应的代理人身份证明材料会一并删除，确认删除吗？',
                confirmButtonColor: '#ffffff',
                cancelButtonColor: '#ffffff'
            }).then(() => {
                // 代理人删除信息项
                this.dlrDeleteItem(id, index);
            })
                .catch((e) => {
                    console.log(e);
                });
        },

        /**
         * 代理人删除信息项
         * @param {String} id 代理人id
         * @param {Number} index 当前申请人索引
         * @returns {void}
         * */
        dlrDeleteItem(id, index) {
            // 保存代理人删除的id
            !this.dlrDataList[index].isAdd && this.dlrDelIds.push(id);
            // 删除对应的代理人数据
            this.dlrDataList.splice(index, 1);
            // 根据人员id进行对应的身份证明材料的删除
            this.scclDelByRyId(id);
        },

        /**
         * 根据申请人id删除对应的代理人相关信息
         * @param {String} sqrId 申请人id
         * @returns {void}
         * */
        dlrDeleteBySqrId(sqrId) {
            // 当前不存在代理人列表，则直接返回
            if (!this.dlrDataList.length) {
                return;
            }
            // 倒序排查方便删除
            for (let i = this.dlrDataList.length - 1; i >=0; i--) {
                // 信息项
                const _item = this.dlrDataList[i];
                // 申请人id数组
                const _cBqSqrids = _item.cBqSqrid.split(',');
                // 索引
                const _index = _cBqSqrids.indexOf(sqrId);
                if (_index > -1) {
                    _cBqSqrids.splice(_index, 1);
                    // 如果长度为0，则进行代理人删除，否则进行申请人id删除
                    if (!_cBqSqrids.length) {
                        // 删除对应的代理人信息项
                        this.dlrDeleteItem(_item[this.dlrIdProp], i);
                    } else {
                        // id字符串赋值
                        _item.cBqSqrid = _cBqSqrids.join(',');
                        // 对应的id数组赋值
                        _item.cBqSqrids = _cBqSqrids;
                    }
                }
            }
        },

        /**
         * 取消添加、编辑代理人
         * @returns {void}
         * */
        dlrCancel() {
            // 编辑信息项置为null
            this.dlrEditItem = null;
            // 索引置为-1
            this.dlrEditIndex = -1;
            // 代理人弹层为false
            this.dlrShowPopup = false;
        },

        /**
         * 获取转化代理人数据
         * @param {Object} formData 表单数据
         * @returns {Object} 转化之后的数据
         * */
        dlrGetTransformData(formData) {
            const _transformData = {
                ...formData
            };
            return _transformData;
        },

        /**
         * 代理人上传材料显示名称
         * @param {Object} 代理人信息项数据
         * @returns {String}
         * */
        dlrGetScclName(itemData) {
            return `${this.dlrLabel}-${itemData.cDlrxm}-${itemData.cDlrlxText}`;
        },

        /**
         * 处理代理人确认操作
         * @param {Object} formData 表单数据
         * @returns {void}
         * */
        dlrHandlerConfirm(formData) {
            const _transformData = this.dlrGetTransformData(formData);
            // 索引
            let _index = this.sqrDataList.length + this.bsqrDataList.length;
            // 如果编辑数据，则说明是编辑数据
            if (this.dlrEditItem && this.dlrEditIndex > -1) {
                // 进行数据替换
                this.dlrDataList.splice(this.dlrEditIndex, 1, _transformData);
                _index += this.dlrEditIndex;
            } else {
                _index += this.dlrDataList.length;
                // 添加数据
                this.dlrDataList.push(_transformData);
            }
            // 新增的时候需要对应的实际id赋值为cId
            _transformData.isAdd && (_transformData[this.dlrIdProp] = _transformData.cId);
            // 同步人员名称
            this.scclSyncDataByRyId(_transformData[this.dlrIdProp], this.dlrGetScclName(_transformData), _index, 1);
        },

        /**
         * 添加、编辑代理人表单确认操作
         * @param {Object} formData 表单数据
         * @returns {void}
         * */
        dlrConfirm(formData) {
            // 确认处理操作
            this.dlrHandlerConfirm(formData);
            // 代理人取消为false
            this.dlrCancel();
        },

        /**
         * 添加并继续
         * @param {Object} formData 表单数据
         * @returns {void}
         * */
        dlrConfirmAContinue(formData) {
            // 确认处理操作
            this.dlrHandlerConfirm(formData);
        }
    }
};
